import paginateAction from '@utils/paginateAction';
import { moderatorTypes } from '../constants';
import { paginatorListSchema } from '../schemas';

const getEducators = (isVerified, query, resetWithoutEmpty) => (next) => ({
  type: moderatorTypes.FETCH_EDUCATORS,
  endpoint: next,
  method: 'get',
  resetWithoutEmpty,
  schema: paginatorListSchema,
  key: `educators_${isVerified}_${query}`,
  directPaginatedEntity: true,
  entityType: 'user'
});

export const fetchEducators = (
  query,
  isVerified,
  nextPage,
  resetWithoutEmpty = false
) =>
  paginateAction(
    `v1/users/all/?limit=50&&search=${query}&is_verified_educator=${isVerified}&ordering=-become_educator_at`,
    getEducators(isVerified, query, resetWithoutEmpty),
    'educators',
    `educators_${isVerified}_${query}`,
    resetWithoutEmpty
  )(nextPage);

export const editAccess = (grant, permission, username) => ({
  type: moderatorTypes.EDIT_ACCESS,
  endpoint: `v1/user/educator_access_management/${grant ? 'grant' : 'revoke'}/`,
  method: 'post',
  username,
  grant,
  key:
    permission === 'create_plus_course'
      ? 'canAddPlusCourse'
      : 'canAddSpecialClass',
  data: { permission, username }
});

const getPlusCourses =
  (status, progType, query, username, resetWithoutEmpty) => (next) => ({
    type: moderatorTypes.FETCH_COURSES,
    endpoint: next,
    method: 'get',
    resetWithoutEmpty,
    schema: paginatorListSchema,
    key: `courses_${progType}_${status}_${query}_${username}`
  });

export const fetchPlusCourses = (
  nameQuery,
  status,
  progType = '',
  username = '',
  nextPage,
  resetWithoutEmpty = false
) =>
  paginateAction(
    `v1/uplus/dashboard/programmes/filter_all/?prog_type=${progType}&prog_name=${nameQuery}&username=${username}&status=${
      status !== -1 ? status : ''
    }`,
    getPlusCourses(status, progType, nameQuery, username, resetWithoutEmpty),
    'modPlusCourses',
    `courses_${progType}_${status}_${nameQuery}_${username}`,
    resetWithoutEmpty
  )(nextPage);

const getLessons = (status, type, query, resetWithoutEmpty) => (next) => ({
  type: moderatorTypes.FETCH_LESSONS,
  endpoint: next,
  method: 'get',
  resetWithoutEmpty,
  schema: paginatorListSchema,
  key: `lessons_${status}_${type}_${query}`
});

export const fetchLessons = (
  query,
  state,
  type,
  nextPage,
  resetWithoutEmpty = false
) =>
  paginateAction(
    `v1/posts/all/?limit=50&search=${query}&search_type=${type}&is_active=${state}`,
    getLessons(state, type, query, resetWithoutEmpty),
    'modLessons',
    `lessons_${state}_${type}_${query}`,
    resetWithoutEmpty
  )(nextPage);

export const fetchPost = (id) => ({
  type: moderatorTypes.FETCH_POST,
  endpoint: `v1/post/${id}/`,
  method: 'get'
});
